export var TelemetryType = {
  log: 'log',
  configuration: 'configuration'
};
export var TelemetryStatusType = {
  debug: 'debug',
  error: 'error'
};
//# sourceMappingURL=types.js.map